/* AgentProfileCardCompiled.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./AgentProfileCardCompiled.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl-next';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { AgentAvatar, AgentBanner, AgentProfileCreator, AgentProfileInfo, AgentStarCount } from '@atlaskit/rovo-agent-components';
import { useAnalyticsEvents as useAnalyticsEventsNext } from '@atlaskit/teams-app-internal-analytics';
import { fireEvent, PACKAGE_META_DATA, profileCardRendered } from '../../util/analytics';
import { getPageTime } from '../../util/performance';
import { LoadingState } from '../common/LoadingState';
import { ErrorMessage } from '../Error';
import { AgentActions } from './Actions';
import { AgentProfileCardWrapper } from './AgentProfileCardWrapper';
import { ConversationStarters } from './ConversationStarters';
import { useAgentUrlActions } from './hooks/useAgentActions';
import { messages } from './messages';
var styles = {
  detailWrapper: "_18zrpxbi _1q51xy5q",
  avatarStyles: "_kqswstnw _154i1ejb _1ltvpxbi",
  cardContainerStyles: "_2rko1mok _16qs130s _kqswh2mm"
};
var AgentProfileCard = function AgentProfileCard(_ref) {
  var _agent$user_defined_c, _agent$external_confi, _agent$external_confi2, _agent$creatorInfo, _agent$creatorInfo2, _agent$creatorInfo3, _agent$creatorInfo4;
  var agent = _ref.agent,
    isLoading = _ref.isLoading,
    cloudId = _ref.cloudId,
    onChatClick = _ref.onChatClick,
    hasError = _ref.hasError,
    errorType = _ref.errorType,
    onConversationStartersClick = _ref.onConversationStartersClick,
    resourceClient = _ref.resourceClient,
    addFlag = _ref.addFlag,
    onDeleteAgent = _ref.onDeleteAgent,
    hideMoreActions = _ref.hideMoreActions;
  var _useAgentUrlActions = useAgentUrlActions({
      cloudId: cloudId || '',
      source: 'agentProfileCard'
    }),
    _onEditAgent = _useAgentUrlActions.onEditAgent,
    _onCopyAgent = _useAgentUrlActions.onCopyAgent,
    _onDuplicateAgent = _useAgentUrlActions.onDuplicateAgent,
    onOpenChatFullScreen = _useAgentUrlActions.onOpenChat,
    onConversationStarter = _useAgentUrlActions.onConversationStarter,
    onViewFullProfile = _useAgentUrlActions.onViewFullProfile;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isStarred = _useState2[0],
    setIsStarred = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    starCount = _useState4[0],
    setStarCount = _useState4[1];
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useAnalyticsEventsNe = useAnalyticsEventsNext(),
    fireAnalyticsNext = _useAnalyticsEventsNe.fireEvent;
  var userDefinedConversationStarters = agent === null || agent === void 0 || (_agent$user_defined_c = agent.user_defined_conversation_starters) === null || _agent$user_defined_c === void 0 ? void 0 : _agent$user_defined_c.map(function (starter) {
    return {
      message: starter,
      type: 'user-defined'
    };
  });
  useEffect(function () {
    setIsStarred(!!(agent !== null && agent !== void 0 && agent.favourite));
    setStarCount(agent === null || agent === void 0 ? void 0 : agent.favourite_count);
  }, [agent === null || agent === void 0 ? void 0 : agent.favourite, agent === null || agent === void 0 ? void 0 : agent.favourite_count]);
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var fireAnalytics = useCallback(function (payload) {
    if (createAnalyticsEvent) {
      fireEvent(createAnalyticsEvent, payload);
    }
  }, [createAnalyticsEvent]);
  var handleSetFavourite = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(agent !== null && agent !== void 0 && agent.id)) {
            _context.next = 10;
            break;
          }
          _context.prev = 1;
          _context.next = 4;
          return resourceClient.setFavouriteAgent(agent.id, !isStarred, fireAnalytics, fireAnalyticsNext);
        case 4:
          if (isStarred) {
            setStarCount(starCount ? starCount - 1 : 0);
          } else {
            setStarCount((starCount || 0) + 1);
          }
          setIsStarred(!isStarred);
          _context.next = 10;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](1);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 8]]);
  })), [agent === null || agent === void 0 ? void 0 : agent.id, fireAnalytics, fireAnalyticsNext, isStarred, resourceClient, starCount]);
  var handleOnDelete = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _onDeleteAgent, restore;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(agent && onDeleteAgent)) {
            _context2.next = 12;
            break;
          }
          // Optimistically remove from cache
          _onDeleteAgent = onDeleteAgent(agent.id), restore = _onDeleteAgent.restore;
          _context2.prev = 2;
          _context2.next = 5;
          return resourceClient.deleteAgent(agent.id, fireAnalytics, fireAnalyticsNext);
        case 5:
          addFlag === null || addFlag === void 0 || addFlag({
            title: formatMessage(messages.agentDeletedSuccessFlagTitle),
            description: formatMessage(messages.agentDeletedSuccessFlagDescription, {
              agentName: agent.name
            }),
            type: 'success',
            id: 'ptc-directory.agent-profile.delete-agent-success'
          });
          _context2.next = 12;
          break;
        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](2);
          // Restore agent to cache on error
          restore();
          addFlag === null || addFlag === void 0 || addFlag({
            title: formatMessage(messages.agentDeletedErrorFlagTitle),
            description: formatMessage(messages.agentDeletedErrorFlagDescription),
            type: 'error',
            id: 'ptc-directory.agent-profile.delete-agent-error'
          });
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 8]]);
  })), [addFlag, agent, formatMessage, onDeleteAgent, resourceClient, fireAnalytics, fireAnalyticsNext]);
  useEffect(function () {
    if (!isLoading && agent) {
      if (fg('ptc-enable-profile-card-analytics-refactor')) {
        fireAnalyticsNext("ui.rovoAgentProfilecard.rendered.content", _objectSpread(_objectSpread({}, PACKAGE_META_DATA), {}, {
          firedAt: Math.round(getPageTime())
        }));
      } else {
        fireAnalytics(profileCardRendered('agent', 'content'));
      }
    }
  }, [agent, fireAnalytics, isLoading, fireAnalyticsNext]);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(AgentProfileCardWrapper, null, /*#__PURE__*/React.createElement(LoadingState, {
      profileType: "agent",
      fireAnalytics: fireAnalytics,
      fireAnalyticsNext: fireAnalyticsNext
    }));
  }
  if (hasError || !agent) {
    return /*#__PURE__*/React.createElement(AgentProfileCardWrapper, null, /*#__PURE__*/React.createElement(ErrorMessage, {
      fireAnalyticsNext: fireAnalyticsNext,
      errorType: errorType,
      fireAnalytics: fireAnalytics
    }));
  }
  return /*#__PURE__*/React.createElement(AgentProfileCardWrapper, null, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.cardContainerStyles
  }, /*#__PURE__*/React.createElement(AgentBanner, {
    agentId: agent.id,
    agentNamedId: (_agent$external_confi = agent.external_config_reference) !== null && _agent$external_confi !== void 0 ? _agent$external_confi : agent.named_id,
    height: 96,
    agentIdentityAccountId: agent.identity_account_id
  }), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.avatarStyles
  }, /*#__PURE__*/React.createElement(AgentAvatar, {
    agentId: agent.id,
    agentNamedId: (_agent$external_confi2 = agent.external_config_reference) !== null && _agent$external_confi2 !== void 0 ? _agent$external_confi2 : agent.named_id,
    agentIdentityAccountId: agent.identity_account_id,
    size: "xlarge",
    isForgeAgent: agent.creator_type === 'FORGE' || agent.creator_type === 'THIRD_PARTY',
    forgeAgentIconUrl: agent.icon
  })), /*#__PURE__*/React.createElement(Stack, {
    space: "space.100",
    xcss: styles.detailWrapper
  }, /*#__PURE__*/React.createElement(AgentProfileInfo, {
    agentName: agent.name,
    isStarred: isStarred,
    onStarToggle: handleSetFavourite,
    isHidden: agent.visibility === 'PRIVATE',
    creatorRender: ((_agent$creatorInfo = agent.creatorInfo) === null || _agent$creatorInfo === void 0 ? void 0 : _agent$creatorInfo.type) && /*#__PURE__*/React.createElement(AgentProfileCreator, {
      creator: {
        type: (_agent$creatorInfo2 = agent.creatorInfo) === null || _agent$creatorInfo2 === void 0 ? void 0 : _agent$creatorInfo2.type,
        name: ((_agent$creatorInfo3 = agent.creatorInfo) === null || _agent$creatorInfo3 === void 0 ? void 0 : _agent$creatorInfo3.name) || '',
        profileLink: ((_agent$creatorInfo4 = agent.creatorInfo) === null || _agent$creatorInfo4 === void 0 ? void 0 : _agent$creatorInfo4.profileLink) || ''
      },
      isLoading: false,
      onCreatorLinkClick: function onCreatorLinkClick() {}
    }),
    starCountRender: /*#__PURE__*/React.createElement(AgentStarCount, {
      starCount: starCount,
      isLoading: false
    }),
    agentDescription: agent.description
  }), /*#__PURE__*/React.createElement(ConversationStarters, {
    isAgentDefault: agent.is_default,
    userDefinedConversationStarters: userDefinedConversationStarters,
    onConversationStarterClick: function onConversationStarterClick(conversationStarter) {
      onConversationStartersClick ? onConversationStartersClick(conversationStarter) : onConversationStarter({
        agentId: agent.id,
        prompt: conversationStarter.message
      });
    }
  })), /*#__PURE__*/React.createElement(AgentActions, {
    agent: agent,
    onEditAgent: function onEditAgent() {
      return _onEditAgent(agent.id);
    },
    onCopyAgent: function onCopyAgent() {
      return _onCopyAgent(agent.id);
    },
    onDuplicateAgent: function onDuplicateAgent() {
      return _onDuplicateAgent(agent.id);
    },
    onDeleteAgent: handleOnDelete,
    onChatClick: onChatClick ? function (event) {
      return onChatClick(event);
    } : function () {
      return onOpenChatFullScreen(agent.id, agent.name);
    },
    resourceClient: resourceClient,
    onViewFullProfileClick: function onViewFullProfileClick() {
      return onViewFullProfile(agent.id);
    },
    hideMoreActions: hideMoreActions
  })));
};
export default AgentProfileCard;